import formSelect from '../elementLp1/select/component.vue';
import fetchSelect from '../elementLp1/fetchSelect/component.vue';
import fetchSuggestSelect from '../elementLp1/fetchSuggestSelect/component.vue';
import formCheck from '../elementLp1/check/component.vue';
import formRadio from '../elementLp1/radio/component.vue';
import formText from '../elementLp1/text/component.vue';
import formInput from '../elementLp1/input/component.vue';
import errorMessage from '../elementLp1/errorMessage/component.vue';
import step from '../elementLp1/step/component.vue';
import stepGroup from './stepGroup/component.vue';

export default {
  'v-form-select': formSelect,
  'v-form-fetch-select': fetchSelect,
  'v-form-fetch-suggest-select': fetchSuggestSelect,
  'v-form-check': formCheck,
  'v-form-radio': formRadio,
  'v-form-text': formText,
  'v-form-input': formInput,
  'errorMessage': errorMessage,
  'v-form-step': step,
  'v-form-step-group': stepGroup,
};
